export const SIDEBAR_SHOW = 'sidebarShow';